import { isNullOrUndefined } from './isNullOrUndefined';

export const mapNotUndefinedOrNull = <T extends unknown, R extends unknown>(
  list: T[],
  map: (value: T) => R,
): NonNullable<R>[] =>
  list.reduce((acc: NonNullable<R>[], value: T) => {
    const mappedValue = map(value);

    return isNullOrUndefined(mappedValue)
      ? acc
      : [...acc, mappedValue as NonNullable<R>];
  }, []);

export const filterNotUndefinedOrNull = <T extends unknown, R extends unknown>(
  list: T[],
): NonNullable<R>[] =>
  list.reduce(
    (acc: NonNullable<R>[], value: T) =>
      isNullOrUndefined(value) ? acc : [...acc, value as NonNullable<R>],
    [],
  );

type Primitive = string | number | bigint | boolean | symbol | undefined | null;

export const primitiveListsAreEqual = <T extends Primitive>(
  list1: T[],
  list2: T[],
): boolean => {
  return list1.toString() === list2.toString();
};

export const listIsDefinedAndHasElements = <T extends unknown>(
  list: T[] | undefined,
): list is T[] & boolean => !isNullOrUndefined(list) && list.length > 0;

export const sum = (list: number[]): number =>
  list.reduce((acc, num) => acc + num, 0);

export const flatten = <T,>(list: T[], flattenWith: (element: T) => T[]): T[] =>
  list.flatMap((element: T) => [
    element,
    ...flatten(flattenWith(element), flattenWith),
  ]);
